// export const key = '4cf0f71594bf3a7ff0e20de254f69b9a'

export const development = 'https://sxbwygzhapi.chwhyun.cn' // 线上
// export const development = 'http://192.168.200.59:8003' // 20250327畅本地
// export const development = 'http://192.168.0.156:8003' // 线上
// export const development = 'http://test8.chwhyun.com' // 线上
// https://sxbwygzhapi.chwhyun.cn
// export const development = 'http://192.168.1.44:8003' // 飞
// export const development = 'http://192.168.1.157:8003' // 健
// export const development = 'http://192.168.1.131:8003' // 欢
// export const development = 'http://192.168.1.105:8003' // 军
export const production = 'https://sxbwygzhapi.chwhyun.cn'
// export const production = 'http://192.168.0.156:8003'
// export const production = 'http://test8.chwhyun.com'
